import { Result } from "./common";

export interface CafeMenuName {
  slnuid: number;
  slnshpid: number;
  shpShipName: string;
  slnName: string;
  slndpluid: number;
  slnDefault: boolean;
  slnltyuid: number;
  ltyname: string;  
}

export interface CafeMenuNamesList {
  Result: Result;
  CafeMenuNamesList: CafeMenuName[];
}

export interface CafeMenuNamesListResponse {
  GetCafeMenuNames: CafeMenuNamesList;
}

export class CafeMenuNamesListRequestBody {
  slnshpid: number | undefined;
  ltyname: string | undefined;

  constructor(slnshpid: number | undefined, ltyname: string | undefined) {
    this.slnshpid = slnshpid;
    this.ltyname = ltyname;
  }
}